import { createApiClient } from "@growing/api";

// Student-web용 API Client 생성
export const apiClient = createApiClient({
  role: "student",
  localStorageKey: "growing-student-user",
  loginRedirectPath: "/auth/login",
  handle403: true, // student는 승인 대기 상태 처리
  pendingApprovalPath: "/pending-approval",
  baseURL: import.meta.env.VITE_API_URL || "/backend-api",
});
